import React, { useRef } from 'react';
import MPU from './product_images/MPU.png';
import PMS from './product_images/PMS.jpg';
import picker from './product_images/picker.JPG';
import card_press from './product_images/card_press.png';
import degating from './product_images/degating.png';
import circuit_tester from './product_images/circuit_tester.png';
import rfid from './product_images/rfid.png';
import robot from './product_images/robot.png';


const products = [
   {
    title: 'Mold Protection System',
    description:
      'A computerized visual inspection system that identifies residual plastic inside molds, in injection molding. Prevents mold damage that can occur due to stuck particles or ejection issues. Integrates with all types of molding machines for fully automatic operation of molding, without the need for continuous manual inspection. Supports remote monitoring, early fault detection, and predictive maintenance to minimize damage, reduce production downtime, and improve mold life.',
    image: MPU,
  },
  {
    title: 'Production Monitoring Software',
    description:
      'A real-time dashboard that continuously tracks production performance and status in injection molding (customizable for different productions). Designed to provide actionable insights for improving manufacturing efficiency and reducing production delays.',
    image: PMS,
  },
 
  {
    title: 'Injection Molding Sprue Picker Robot',
    description:
      'A pneumatic-powered automatic robotic arm for efficiently removing molded sprues in injection molding. Synchronizes with the molding machine\'s operation, and safely extracts the part to prevent potential mold damage. Replaces manual operation and improves production efficiency.',
    image: picker,
  },
  {
    title: 'Desktop Pneumatic Press with Sliding Bed',
    description:
      'A compact, multi-purpose semi-automatic press machine that applies controlled pneumatic pressure up to 50kg. Synchronized horizontal sliding bed for improved safety and efficient operation. Equipped with automation controls and safety sensors.',
    image: card_press,
  },
  {
    title: 'Heavy Duty Pneumatic Cutting Press',
    description:
      'A heavy duty, pneumatic-powered, plastic cutter unit. Configurable cutting locations, to support different cutting patterns. Cutting load up to 750kg. Synchronized horizontal sliding bed for improved safety and efficient operation. Equipped with automation controls and safety sensors. Easy sorting and collection of cut parts. (Example use: custom de-gating of molded plastic parts from sprues)',
    image: degating,
  },
  {
    title: 'Audio Tester for Mass Produced Electronic Circuits',
    description:
      'An automated audio inspection device, to ensure the quality of recorded audio on mass produced electronic circuits using advanced signal processing. Configurable circuit interface to support a variety of circuits, and a record mode to support different audio tracks. Allows testing of up to 8 circuits at a time.',
    image: circuit_tester,
  },
  {
    title: 'RFID Asset Manager',
    description:
      'A UHF RFID–based asset/item management system for locating, tracking, and monitoring assets in warehouses. Allows for fast and easy locating of assets/items. Provides software-driven analytics on asset/item usage and availability to streamline planning.',
    image: rfid,
  },
  // {
  //   title: 'Interactive Self Service PoS System',
  //   description:
  //     'Next generation self-service PoS system for high-end food service experiences. A modular system with interactive characters for a unique user experience. Table-mounted touchscreen PoS terminal to handle order placement and payments. Full wireless operation for hassle free use and maintenance.',
  //   image: robot,
  // },
];

const Portfolio = () => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320; // Adjust based on card width
      scrollRef.current.scrollBy({
        left: direction === 'next' ? scrollAmount : -scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      <div id="products" className="bg-gray-100 py-20">
        <h2 className="my-2 text-center text-3xl uppercase font-bold" style={{ color: '#005690' }}>
          Products
        </h2>
        <div className="flex justify-center">
          <div className="w-24 border-b-4 mb-8" style={{ borderColor: '#005690' }}></div>
        </div>

        <div className="px-4 overflow-hidden relative">
          <button
            className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow p-2 z-10"
            onClick={() => scroll('prev')}
            aria-label="Previous"
          >
            &#8592;
          </button>
          <button
            className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-white rounded-full shadow p-2 z-10"
            onClick={() => scroll('next')}
            aria-label="Next"
          >
            &#8594;
          </button>
          <div
            ref={scrollRef}
            className="flex space-x-8 pb-4 overflow-x-auto scrollbar-hide"
            style={{ scrollBehavior: 'smooth' }}
          >
            {products.map((product, index) => (
              <div
                key={index}
                className="bg-white transition-all duration-300 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-lg flex flex-col"
                style={{
                  minWidth: '320px',
                  maxWidth: '400px',
                  width: '100%'
                }}
              >
                {/* Title Section */}
                <div className="p-4 pb-2">
                  <h4
                    className="font-semibold text-base text-center px-3 py-2 rounded-xl line-clamp-2"
                    style={{
                      background: 'rgba(255, 255, 255, 0.35)',
                      backdropFilter: 'blur(6px)',
                      WebkitBackdropFilter: 'blur(6px)',
                      border: '1px solid rgba(255,255,255,0.4)',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                      minHeight: '3.5rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    {product.title}
                  </h4>
                </div>

                {/* Image Section - Fixed size */}
                <div 
                  className="p-4 flex justify-center items-center"
                  style={{
                    height: '240px',
                    background: '#f8f9fa'
                  }}
                >
                  <img
                    src={product.image}
                    alt={product.title}
                    className="rounded-lg"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '220px',
                      objectFit: 'contain',
                      display: 'block'
                    }}
                  />
                </div>

                {/* Description Section */}
                <div className="p-4 pt-2 flex-grow">
                  <p className="text-sm text-gray-600 text-justify">
                    {product.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Portfolio;
